import React from 'react'
import classNames from 'classnames'
import classes from './CartItem.module.css'
import { ReactComponent as HeartIcon } from '../../assets/icons/heart.svg'
import { ReactComponent as CloseIcon } from '../../assets/icons/x-icon.svg'
import { ReactComponent as CreditCard } from '../../assets/images/credit-card.svg'
import { ReactComponent as ClockIcon } from '../../assets/images/clock-icon.svg'
import { ReactComponent as SlotsIcon } from '../../assets/images/ticket.svg'
import moment from 'moment'
import Image from '../Image/Image'
import coursePlaceholder from '../../assets/images/course-placeholder-no-padding.svg'

export const CourseCartItem = ({
    image,
    title,
    price,
    isWishlisted = false,
    onRemove,
    onWishlist,
    className,
    ...props
}) => (
    <div className={classNames(classes.cartItem, className)} {...props}>
        <div className={classes.cartItemLeft}>
            <div className={classes.cartItemImageContainer}>
                <Image
                    src={image}
                    alt={title}
                    className={classes.cartItemImage}
                    errorImageUrl={coursePlaceholder}
                />
            </div>
            <div className={classes.cartItemMeta}>
                <p className={classes.cartItemTitle}>{title}</p>
                {/* TODO: Format currency properly */}
                <p className={classes.cartItemPrice}>{price}</p>
            </div>
        </div>
        <div
            className={classes.cartItemRight}
            // style={{ justifyContent: 'flex-end' }}
        >
            <button
                onClick={onWishlist}
                className={classNames(
                    classes.cartItemWishlist,
                    isWishlisted && classes.cartItemWishlisted
                )}
            >
                <span className={classes.cartItemWishlistText}>Wishlist</span>
                <HeartIcon className={classes.cartItemWishlistIcon} />
            </button>
            <button onClick={onRemove} className={classes.cartItemRemoveIcon}>
                <CloseIcon />
            </button>
        </div>
        <div className={classes.topBorder} />
    </div>
)

export const SubscriptionCartItem = ({
    name,
    price,
    duration: { start, end } = {},
    className,
    ...props
}) => (
    <div
        className={classNames(
            classes.cartItem,
            classes.subscriptionCartItem,
            className
        )}
        {...props}
    >
        <div className={classes.cartItemLeft}>
            <div className={classes.cartItemImageContainer}>
                <CreditCard className={classes.cardImage} />
            </div>
            <div className={classes.cartItemMeta}>
                <p className={classes.cartItemTitle}>{name}</p>
                {/* TODO: Format currency properly */}
                <p className={classes.cartItemPrice}>{price}</p>
                <div className={classes.cartItemDuration}>
                    <p className={classes.cartItemDurationTitle}>Payment for</p>
                    {/* TODO: Format dates with moment */}
                    <p className={classes.cartItemDurationText}>
                        {start} - {end}
                    </p>
                </div>
            </div>
        </div>
    </div>
)

export const ClassCartItem = ({
    date,
    time,
    title,
    price,
    slots,
    isWishlisted = false,
    onRemove,
    onWishlist,
    className,
    ...props
}) => (
    <div className={classNames(classes.cartItem, className)} {...props}>
        <div className={classes.cartItemLeft}>
            <div className={classes.cartItemDateContainer}>
                <div className={classes.cartItemDate}>
                    <span className={classes.cartItemDateText}>
                        {moment(date).format('ddd')}
                    </span>
                    <span className={classes.cartItemDateNumber}>
                        {moment(date).format('MM')}
                    </span>
                </div>
            </div>
            <div className={classes.cartItemMeta}>
                <div className={classes.cartItemTextRows}>
                    <p className={classes.cartItemTitle}>{title}</p>
                    <div className={classes.cartItemClassDetails}>
                        <div className={classes.cartItemClassDetail}>
                            <ClockIcon />
                            <span className={classes.cartItemClassDetailText}>
                                {moment(date).format('ddd, MMM DD')}, {time}
                            </span>
                        </div>
                        <div className={classes.cartItemClassDetail}>
                            <SlotsIcon />
                            <span className={classes.cartItemClassDetailText}>
                                {slots} slots
                            </span>
                        </div>
                    </div>
                </div>
                <p className={classes.cartItemPrice}>{price}</p>
            </div>
        </div>
        <div
            className={classes.cartItemRight}
            // style={{ justifyContent: 'flex-end' }}
        >
            <button
                onClick={onWishlist}
                className={classNames(
                    classes.cartItemWishlist,
                    isWishlisted && classes.cartItemWishlisted
                )}
            >
                <span className={classes.cartItemWishlistText}>Wishlist</span>
                <HeartIcon className={classes.cartItemWishlistIcon} />
            </button>
            <button onClick={onRemove} className={classes.cartItemRemoveIcon}>
                <CloseIcon />
            </button>
        </div>
        <div className={classes.topBorder} />
    </div>
)
